import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import TextareaCounter from './../../FormComponents/TextareaCounterTop';
import DatePicker from 'react-datepicker';
import ReactTooltip from 'react-tooltip';
import CircularProgressBar from '../StatusBar/CircularProgressBar';
import Submissions from '../Submissions';
import 'react-datepicker/dist/react-datepicker.css';
import { NavLink } from 'react-router-dom';

import './index.scss';

import Loading from '../../common/Loading';
import helper from '../../Conversations/helpers';

const formatPhonenumber = (phonenumber)=>{
  if(phonenumber){
      return phonenumber.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "$1 ($2) $3-$4");
  }
  return phonenumber;
};

const getWindowDimensions =()=>{
  const { innerWidth: width } = window;
  if(width>768){
    return { radius: 60 , stroke:13}
  }else{
    return { radius: 60 , stroke:13}
  }
}

class AddCampaign extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      list_of_months: this.getMonths(5),
      name:'',
      year_month:moment().format('YYYY-MM'),
      submission_reports:[],
      sortby: null,
      order:false,
      webhook:null

    };
  }

  componentDidMount =()=>{
    const { match: { params } } = this.props;
    if(params.id){
      this.props.getLeadReport({id:params.id, year_month:moment().format('YYYY-MM')});
    }
  }
  componentWillReceiveProps=(nextProps)=>{
    if(nextProps.formresponse && nextProps.formresponse.gettingLeadReport===false && this.props.formresponse.gettingLeadReport != nextProps.formresponse.gettingLeadReport){
      const { campaign_name,year_month, submission_reports, created_year_month, webhook } = nextProps.formresponse.report;
      this.setState({
        name: campaign_name,
        year_month:year_month,
        submission_reports:submission_reports,
        webhook: webhook,
        list_of_months: this.getMonths(5).filter(date=>moment(date.key).isAfter(moment(created_year_month)) || moment(date.key).isSame(moment(created_year_month))),
      },this.sortSubmissionReport('time'));
    }
  }

  onMonthChange = ( event )=>{
    const { formresponse } = this.props;
    const { report } = formresponse;
    this.props.getLeadReport({id:report.campaign_id, year_month:event.target.value});
  }
  getMonths = (no_of_months) => {
    let monthList = [];
    while (no_of_months > -1) {
      monthList.push({ 'key': moment().subtract(no_of_months, 'months').format('YYYY-MM'), 'value': moment().subtract(no_of_months, 'months').format('MMM YYYY') });
      no_of_months--;
    };
    return monthList.reverse();
  }

  downloadReport = () =>{
    const { formresponse } = this.props;
    const { report } = formresponse;
    let file = window.Config.API_URL+'/business/lead_engage/campaign/'+report.campaign_id+'/report?year_month='+report.year_month;
    window.open(file);
  }

  sortSubmissionReport =(field)=>{
    const report = [].concat(this.state.submission_reports);
    const { order } = this.state;
    let sortorder = order;
    if(this.state.sortby === field){
      report.reverse();
      sortorder = !sortorder;
    }else{
      if(field==='booking'){
        report.sort((a,b)=>a.user_booked-b.user_booked);
        report.reverse();
      }else{
        report.sort((a,b)=>new Date(a.form_submission_time)- new Date(b.form_submission_time));
      }
      sortorder =true;
    }
    this.setState({
      submission_reports:report,
      sortby:field,
      order:sortorder
    })
  }

  render() {
    const {formresponse, auth } = this.props;
    const { name, list_of_months, year_month , submission_reports, sortby, order, webhook } = this.state;
    let device = getWindowDimensions();
    return (
      <div className="campaign-report">
        { formresponse.gettingLeadReport===true ?
        (<div className="campaign-report_loader">
        <Loading />
        </div>):
        (
        <div className='campaign-report_title'>
          <div className="campaign-report_title_content">
              <div className="title" onClick={()=>this.props.history.goBack()}>
                  <span className="material-icons">arrow_back</span>
                  <span className="back-text">All campaigns</span>
              </div>
          </div>
          <div className="campaign-report_title_meta">
            <div className="name" >
              <div id="name-input" className="input-name">{name}</div>
            </div>
            <div className="campaign-report_title_webhook show-field-in-mobile">
                <div className="title">Webhook URL: </div><span>{webhook}</span>
            </div>
            <div className="select-group_container">
                        <select className="select-box" value={year_month} onChange={e => this.onMonthChange(e, 'year_month')}>
                          {list_of_months.map(month => {
                            return <option className="select-option" value={month.key} selected={month.key === year_month}>{month.value}</option>
                          })}
                        </select>
                  <i className="material-icons">arrow_drop_down</i>
            </div>
          </div>
          <div className="campaign-report_title_webhook show-field-in-desktop">
            <div className="title">Webhook URL: </div><div>{webhook}</div>
          </div>
          {formresponse && formresponse.report &&
          <div className="campaign-report_campaign">
          <div className="campaign-report_campaign_content">
            <div className="header">
                <div className="title">PERFORMANCE</div>
                <div className="download" onClick={this.downloadReport}><i className="material-icons">download</i> <span>Download report</span></div>
            </div>
            <div className="body">
                <div className="graph"> 
                {formresponse.report.conversion_rate!==undefined &&
                    <div className="progress-bar">
                        <CircularProgressBar 
                        radius={ device.radius }
                        stroke={ device.stroke }
                        progress = {formresponse.report.conversion_rate}
                        color = {'#38C3A6'}
                        />
                        <div className="progress-bar_info">
                        <div className="progress-bar_info_rate" style={{color:'#38C3A6'}}>{formresponse.report.conversion_rate}%</div>
                        <div className="progress-bar_info_label" data-multiline={true} data-tip-disable={moment(year_month).isBefore('2023-09')} data-tip={'Includes off-platform Conversion'} >{moment(year_month).isAfter('2023-08')?'Total Lead Conversion':'Total Conversion'}</div>
                        </div>
                        <div className="line-divider"></div>
                    </div>
                   }
                  {formresponse.report.number_of_bookings!==undefined  && 
                    <div className="progress-bar">
                        <div className="booking-info">
                          <div className="booking-info_icon">
                          <i className="material-icons calendar-check">event_available</i>
                          </div>
                        </div>
                        <div className="progress-bar_info">
                        <div className="progress-bar_info_rate" style={{color:'#45ABEA'}}>{moment(year_month).isAfter('2023-08')?formresponse.report.unique_clients_booked:formresponse.report.number_of_bookings}</div>
                        <div className="progress-bar_info_label" data-multiline={true} data-tip-disable={moment(year_month).isBefore('2023-09')} data-tip={'Includes off-platform Bookings'}  >{auth.domain==='FITNESS' ? (moment(year_month).isAfter('2023-08')?'Total Leads enrolled':'Total Enrollments') : (moment(year_month).isAfter('2023-08')?'Total Leads Booked':'Total Bookings')} </div>
                        </div>
                        <div className="line-divider"></div>
                    </div>
                }
                </div>
                {formresponse.report.engagement_metrics &&
                <div className="stats">
                  <ReactTooltip />
                   <table cellpadding="0" cellspacing="0">
                     <thead>
                       <tr>
                         <th> </th>
                         <th><div>Sends</div></th>
                         {moment(year_month).isAfter('2023-08')?
                         (<>
                         <th><div data-multiline={true} data-tip-disable={false} data-tip={'Does not include off-platform engagement'}>Engagement</div></th>
                         <th className="show-field-in-desktop"><div data-multiline={true} data-tip-disable={false} data-tip={'Does not include off-platform bookings'}>Sends resulted in booking</div></th>
                         <th><div data-multiline={true} data-tip-disable={false} data-tip={'Does not include off-platform conversion'}>Conversion</div></th>
                         </>):(
                           <>
                           <th><div>Engagement</div></th>
                           <th className="show-field-in-desktop">
                           {auth.domain==='FITNESS' ? (<div>Sends resulted in enrollment</div>) : (<div>Sends resulted in booking</div>)}
                           </th>
                           <th><div >Conversion</div></th>
                           </>
                         )}
                       </tr>
                     </thead>
                     <tbody>
                       {formresponse.report.engagement_metrics.map(message=>{
                          return(<tr>
                            <td>{message.type}</td>
                            <td className="rate-percentage">{message.sends}</td>
                            <td className="rate-percentage">{message.engagement}%</td>
                            <td className="rate-percentage show-field-in-desktop">{message.number_of_bookings}</td>
                            <td className="conversion-rate">{message.conversion_rate}%</td>
                           </tr>)
                       })}
                     </tbody>
                   </table>
                </div>
                }
            </div>
            </div>
          {submission_reports && <div className="submissions-container"><Submissions submissions={submission_reports} /></div>}
          </div>
          }
         </div>
        )}
      </div>
    );
  }
}
export default AddCampaign;
